
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 4h14v7h2c1.645 0 3 1.355 3 3v10h-5v4H9v-4H4V14c0-1.645 1.355-3 3-3h2V4zm2 2v5h10V6H11zm-4 7c-.565 0-1 .435-1 1v8h3v-4h14v4h3v-8c0-.565-.435-1-1-1H7zm1 1a1 1 0 110 2 1 1 0 010-2zm3 6v6h10v-6H11z"}})])
          )
        }
      }
    